import type { Scene } from "@core/scene-manager";

export interface CreditsSceneDeps {
  element: HTMLElement;
  backButton: HTMLButtonElement;
  onBack: () => Promise<void> | void;
}

/** Сцена credits — минимальная, только back. */
export class CreditsScene implements Scene {
  readonly id = "credits" as const;
  private handler: (() => void) | null = null;

  constructor(private readonly deps: CreditsSceneDeps) {}

  onEnter(): void {
    this.deps.element.classList.add("is-visible");
    this.deps.element.setAttribute("aria-hidden", "false");
    this.handler = () => {
      void this.deps.onBack();
    };
    this.deps.backButton.addEventListener("click", this.handler);
  }

  onExit(): void {
    if (this.handler) this.deps.backButton.removeEventListener("click", this.handler);
    this.handler = null;
    this.deps.element.classList.remove("is-visible");
    this.deps.element.setAttribute("aria-hidden", "true");
  }
}
